import { useEffect, useState } from 'react';
import { FloatingLogo } from '../../components/FloatingLogo';
import { useLanguage } from '../../context/LanguageContext';
import usePlayerContext from '../../context/PlayerContext';
import { ROUTES } from '../../routes';
import { LinkButton, HomeContainer, LeftContent } from './styles';
import { ButtonContainer } from '../../components/Button';
import { useSearchNavigate } from '../../hooks/useSearchNavigate';

export function Home() {
  const { setPlayer } = usePlayerContext();
  const [mounted, setMounted] = useState(false);
  const [pressed, setPressed] = useState(false);
  const [pressedIn, setPressedIn] = useState(false);
  const { language } = useLanguage();
  const navigate = useSearchNavigate();

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    setPlayer(undefined);
  }, [mounted]);

  return (
    <HomeContainer>
      <LeftContent>
        <FloatingLogo className="center-bottom" />

        <h1>{language.citis_new_way}</h1>
        <h2>{language.speed_quiz}</h2>

        <ButtonContainer>
          <LinkButton
            className={pressed ? (pressedIn ? 'pressed' : 'notpressed') : ''}
            onClick={() => {
              setPressed(true);
              setPressedIn(true);
              setTimeout(() => {
                setPressedIn(false);
              }, 500);
              setTimeout(() => {
                navigate(ROUTES.Registration);
              }, 1000);
            }}>
            {language.begin_game}
          </LinkButton>
        </ButtonContainer>
      </LeftContent>
    </HomeContainer>
  );
}
